import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DynamicTabs from "../../../../components/DynamicTabs";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import Subheader from "../../../../Componants/Common/Subheader";
import CommonButton from "../../../../Componants/Common/Button";
import infoIcon from "../../../../Assests/infoIcon.svg";
import deleteIcon from "../../../../Assests/deleteIcon.svg";
import BarcodeIcon from "../../../../Assests/BarcodeIcon.svg";
import {
  fetchBrandList,
  fetchCategoryList,
  fetchSubCategoryList,
  fetchModelList,
  fetchModelListActive,
  getSparePartByModelDropdown,
  transferPartList,
  fetchServieCenterList,
  fetchEngineerList,
  transferPartAllocation,
  importBufferStock,
  checkPartSerialNo,
  downloadTransferStockReferenceCode
} from "../../../../API Service/apiService";
import InputFileUpload from "../../../../Componants/Common/Bulk Upload/InputFileUpload";
import Template from "../../../../Componants/Common/Bulk Upload/Template";
import BulkUploadToast from "../../../../Componants/Common/Bulk Upload/BulkUploadToast";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import BulkUploadSection from "../../../../Componants/Common/Bulk Upload/BulkUploadSection";
const options = [
  { label: "Option 1" },
  { label: "Option 2" },
  { label: "Option 3" },
];
const cell1 = [
  "Part Name",
  "Part Code",
  "Type",
  "Qty Available",
  "Allocate Qty",
  "Serial No.",
  "Count",
];
const cell2 = ["Part Name", "Part Code", "Allocate Qty", "Serial No.", "Count", "Action"];
const mockData = [
  {
    partCode: "xxxx",
    partName: "xxxx",
    qtyAvailable: 1000,
    allocateQty: 0,
    serialNo: "No",
    count: 0,
  },
];
const mockData2 = [
  {
    partCode: "xxxx",
    partName: "xxxx",
    allocateQty: 0,
    serialNo: "No",
    count: 0,
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#EFF3FE",
  boxShadow: 24,
  pt: 1,
  px: 0.5,
  pb: 3,
};

const SerialNoModal = ({ serialNumbers, onClose, onDelete, partCode }) => {
  return (
    <>
      <Box sx={{ ...style, width: "35%" }}>
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#33499F",
            color: "#fff",
            margin: "0",
            padding: "10px",
          }}
        >
          <h4 style={{ margin: 0 }}>Serial Numbers</h4>
        </Box>
        <Grid
          container
          justifyContent={"center"}
          sx={{
            width: "100%",
            paddingTop: "5px",
            margin: "auto",
            padding: "auto",
          }}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{ justifyContent: "center" }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Serial No.
                  </TableCell>
                  <TableCell sx={{ color: "white", textAlign: "center" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serialNumbers.length > 0 ? (
                  serialNumbers.map((serialNo, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{serialNo}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => onDelete(partCode, serialNo)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={deleteIcon}
                            alt="delete"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No Serial Numbers Added
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid container justifyContent={"center"} gap={2} mt={2}>
          <Grid item>
            <CommonButton name={"Close"} handleOnClick={onClose} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const Bufferstockallocation = () => {
  const [selectedValue, setSelectedValue] = useState("UI");
  const [open, setOpen] = useState("");
  const [loading, setLoading] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);

  // States for dropdowns
  const [brandList, setBrandList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [models, setModels] = useState([]);
  const [partList, setPartList] = useState([]);
  const [partTableList, setPartTableList] = useState([]);
  const [partTableList2, setPartTableList2] = useState([]);

  // Selected values
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedPart, setSelectedPart] = useState(null);

  // New states
  const [serialNoMap, setSerialNoMap] = useState({});
  const [selectedPartForModal, setSelectedPartForModal] = useState(null);
  const [serialNoInputs, setSerialNoInputs] = useState({});
  const [allocateListParams, setAllocateListParams] = useState({
    serviceCenterId: "",
    engineerId: "",
    parts: [
      {
        partId: "",
        allocatedQty: 0,
        serialNumber: [],
        isSerialized: null,
      },
    ],
  });

  // Add new states for service centers and engineers
  const [serviceCenterList, setServiceCenterList] = useState([]);
  const [engineerList, setEngineerList] = useState([]);
  const [selectedServiceCenter, setSelectedServiceCenter] = useState(null);
  const [selectedEngineer, setSelectedEngineer] = useState(null);

  // Fetch initial data
  const fetchBrandListData = async () => {
    try {
      setLoading(true);
      const brandResponse = await fetchBrandList();
      setBrandList(brandResponse.data.brandList || []);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      toast.error("Failed to fetch initial data");
    } finally {
      setLoading(false);
    }
  };

  // Fetch categories when brand changes
  useEffect(() => {
    const fetchCategories = async () => {
      if (!selectedBrand?._id) return;
      try {
        setLoading(true);
        const response = await fetchCategoryList(
          selectedBrand._id,
          "",
          1,
          10,
          true
        );
        setCategories(response.data.categories || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to fetch categories");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [selectedBrand]);

  // Fetch subcategories when category changes
  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!selectedBrand?._id || !selectedCategory?._id) return;
      try {
        setLoading(true);
        const response = await fetchSubCategoryList(
          "",
          1,
          10,
          selectedBrand._id,
          selectedCategory._id
        );
        setSubcategories(response.data.subcategory || []);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        toast.error("Failed to fetch subcategories");
      } finally {
        setLoading(false);
      }
    };
    fetchSubcategories();
  }, [selectedCategory, selectedBrand]);

  // Fetch models when subcategory changes
  useEffect(() => {
    const fetchModels = async () => {
      if (
        !selectedBrand?._id ||
        !selectedCategory?._id ||
        !selectedSubcategory?._id
      )
        return;
      try {
        setLoading(true);
        const response = await fetchModelListActive(
          "",
          1,
          10,
          selectedBrand._id,
          selectedCategory._id,
          selectedSubcategory._id
        );
        setModels(response.data.models || []);
      } catch (error) {
        console.error("Error fetching models:", error);
        toast.error("Failed to fetch models");
      } finally {
        setLoading(false);
      }
    };
    fetchModels();
  }, [selectedSubcategory, selectedCategory, selectedBrand]);

  // Fetch part details
  const fetchPartDetailsData = async (modelId) => {
    if (!modelId) return;
    try {
      setLoading(true);
      const params = {
        modelId: modelId,
      };
      const partResponse = await getSparePartByModelDropdown(params);
      if (partResponse.status === "success") {
        setPartList(partResponse.data || []);
      } else {
        setPartList([]);
      }
    } catch (error) {
      console.error("Error fetching part details:", error);
      toast.error("Failed to fetch part details");
      setPartList([]);
    } finally {
      setLoading(false);
    }
  };

  // Update useEffect to fetch parts when model changes
  useEffect(() => {
    setSelectedPart(null);
    if (selectedModel?._id) {
      fetchPartDetailsData(selectedModel._id);
    } else {
      setPartList([]);
    }
  }, [selectedModel]);

  const handleSearch = async () => {
    try {
      if (!selectedServiceCenter?._id) {
        toast.error("Please select Transfer From (Service Center)");
        return;
      }
      if (!selectedEngineer?._id) {
        toast.error("Please select Transfer To (Engineer)");
        return;
      }

      // Check if at least one of modelId or sparePartId is available
      if (!selectedModel?._id && !selectedPart?._id) {
        toast.error("Please select either Model or Part");
        return;
      }

      setLoading(true);
      setPartTableList2([]);
      setSerialNoMap({});
      setSerialNoInputs({});
      let params = {};
      
      // If part is selected, use sparePartId, otherwise use modelId
      if (selectedPart?._id) {
        params = { sparePartId: selectedPart._id,serviceCenterId:selectedServiceCenter?._id };
      } else if (selectedModel?._id) {
        params = { modelId: selectedModel._id,serviceCenterId:selectedServiceCenter?._id};
      }

      const response = await transferPartList(params);
      if (response.status === 200) {
        setPartTableList(response.data.data.finalDetails || []);
      } else {
        setPartTableList([]);
      }
    } catch (error) {
      console.error("Error fetching part details:", error);
      toast.error("Failed to fetch part details");
      setPartTableList([]);
    } finally {
      setLoading(false);
    }
  };
  // Remove fetchPartDetailsData from initial load
  useEffect(() => {
    fetchBrandListData();
    getServiceCenterList();
  }, []);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    handleReset();
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleModal = () => {
    setOpen(true);
  };

  // Function to fetch service centers
  const getServiceCenterList = async () => {
    try {
      setLoading(true);
      const response = await fetchServieCenterList();
      if (response.status === "success") {
        setServiceCenterList(response.data.serviceCenters);
      }
    } catch (error) {
      console.log(`Error in fetching service center list`, error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch engineers based on service center
  const getEngineerList = async (serviceCenterId) => {
    try {
      let params={
        forAssignEngineer:false,
        serviceCenterId,
      }
      setLoading(true);
      const response = await fetchEngineerList(params);
      if (response.status === "success") {
        setEngineerList(response.data.engineers);
      }
    } catch (error) {
      console.log(`Error in fetching engineer list`, error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle adding serial number with synchronized count
  const handleAddSerialNo = async (partCode) => {
    const currentSerialNo = serialNoInputs[partCode] || '';
    if (!currentSerialNo.trim()) {
      toast.error("Please enter a serial number");
      return;
    }
  
    if (!selectedServiceCenter?._id) {
      toast.error("Please select a Service Center first");
      return;
    }
  
    // Find the current part from partTableList
    const currentPart = partTableList.find(part => part.code === partCode);
    if (!currentPart) {
      toast.error("Part not found");
      return;
    }
  
    // Determine the correct partId based on type
    const partId = currentPart.type === 'model' ? currentPart.modelId : currentPart.sparePartId;
    
    if (!partId) {
      toast.error("Invalid part ID");
      return;
    }
  
    // Check for available quantity
    const existingSerialNos = serialNoMap[partCode] || [];
    if (existingSerialNos.length >= currentPart.quantity) {
      toast.error(`Cannot add more serial numbers. Maximum available quantity is ${currentPart.quantity}`);
      setSerialNoInputs(prev => ({ ...prev, [partCode]: '' }));
      return;
    }
  
    // Check for duplicate serial number
    if (existingSerialNos.includes(currentSerialNo)) {
      toast.error("Serial number already exists");
      setSerialNoInputs(prev => ({ ...prev, [partCode]: '' }));
      return;
    }
  
    try {
      // Call checkPartSerialNo API with the correct partId
      const params = {
        serialNumber: currentSerialNo,
        partId: partId, // Using the determined partId
        serviceCenterId: selectedServiceCenter._id
      };
      
      console.log("API params:", params);
      
      const response = await checkPartSerialNo(params);
      
      if (response.status === 200) {
        // Update the serial numbers map
        const updatedSerialNos = [...existingSerialNos, currentSerialNo];
        setSerialNoMap(prev => ({
          ...prev,
          [partCode]: updatedSerialNos
        }));
  
        // Update the part in partTableList with count equal to serial numbers length
        setPartTableList(prev =>
          prev.map(part => {
            if (part.code === partCode) {
              return {
                ...part,
                allocateQty: updatedSerialNos.length,
                count: updatedSerialNos.length
              };
            }
            return part;
          })
        );
  
        setSerialNoInputs(prev => ({ ...prev, [partCode]: '' }));
        toast.success("Serial number added successfully");
      }
    } catch (error) {
      console.error("Error checking serial number:", error);
      toast.error(error.response?.data?.message || "Failed to validate serial number");
      setSerialNoInputs(prev => ({ ...prev, [partCode]: '' }));
    }
  };
  // Add handler for serial number input change
  const handleSerialNoInputChange = (partId, value) => {
    setSerialNoInputs(prev => ({
      ...prev,
      [partId]: value
    }));
  };

  // Function to show serial numbers in modal
  const handleShowSerialNos = (part) => {
    setSelectedPartForModal(part);
    setOpen(true);
  };

  // Function to handle Add to List
  const handleAddToList = () => {
    // Check if there are any parts with allocated quantity
    const partsToAdd = partTableList.filter(part => {
      if (part.isSerialized) {
        return (part.allocateQty || 0) > 0 && serialNoMap[part.code]?.length === part.allocateQty;
      }
      return (part.allocateQty || 0) > 0;
    });
    
    if (partsToAdd.length === 0) {
      toast.error("Please allocate quantity before adding to list");
      return;
    }

    // Check if total quantity exceeds available quantity
    for (const part of partsToAdd) {
      const existingInList = partTableList2.find(item => item.partCode === part.code);
      const newTotal = (existingInList?.allocateQty || 0) + (part.allocateQty || 0);
      if (newTotal > part.quantity) {
        toast.error(`Total allocated quantity for ${part.code} (${newTotal}) exceeds available quantity (${part.quantity})`);
        return;
      }
    }

    // Transform the data for the second table
    const newItems = partsToAdd.map(part => ({
      partName: part.name,
      partCode: part.code,
      allocateQty: part.allocateQty || 0,
      serialNumbers: part.isSerialized ? (serialNoMap[part.code] || []) : [],
      count: part.isSerialized ? (serialNoMap[part.code]?.length || 0) : part.allocateQty,
      partId: part.sparePartId,
      modelId: part.type === 'model' ? part.modelId : null,
      isSerialized: part.isSerialized,
      type: part.type
    }));

    // Update the second table's data with merging logic for existing items
    setPartTableList2(prev => {
      const updatedList = [...prev];
      newItems.forEach(newItem => {
        const existingIndex = updatedList.findIndex(item => item.partCode === newItem.partCode);
        if (existingIndex !== -1) {
          // Merge quantities and serial numbers
          const existingItem = updatedList[existingIndex];
          const mergedSerialNumbers = [...(existingItem.serialNumbers || []), ...(newItem.serialNumbers || [])];
          updatedList[existingIndex] = {
            ...existingItem,
            allocateQty: existingItem.allocateQty + newItem.allocateQty,
            serialNumbers: mergedSerialNumbers,
            count: existingItem.isSerialized ? mergedSerialNumbers.length : (existingItem.allocateQty + newItem.allocateQty)
          };
        } else {
          updatedList.push(newItem);
        }
      });
      return updatedList;
    });

    // Reset the allocation inputs in the first table but keep the list visible
    setPartTableList(prev => prev.map(part => ({
      ...part,
      allocateQty: 0,
      count: 0
    })));
    setSerialNoMap({});
    setSerialNoInputs({});
    
    toast.success("Items added to list successfully");
  };

  // Function to handle quantity change for non-serialized parts
  const handleQuantityChange = (partCode, value) => {
    const numValue = parseInt(value) || 0;
    setPartTableList(prev => 
      prev.map(part => {
        if (part.code === partCode) {
          // Check if quantity is not more than available
          if (numValue > part.quantity) {
            toast.error("Cannot allocate more than available quantity");
            return part;
          }
          return {
            ...part,
            allocateQty: numValue,
            count: numValue
          };
        }
        return part;
      })
    );
  };

  // Function to delete serial number with synchronized count
  const handleDeleteSerialNo = (partCode, serialNo) => {
    // Update the serial number map
    setSerialNoMap((prev) => {
      const existingSerialNos = prev[partCode] || [];
      const updatedSerialNos = existingSerialNos.filter(
        (sn) => sn !== serialNo
      );

      if (updatedSerialNos.length === 0) {
        const { [partCode]: _, ...rest } = prev;
        return rest;
      }

      return {
        ...prev,
        [partCode]: updatedSerialNos,
      };
    });

    // Update partTableList2
    setPartTableList2((prev) => {
      const updatedList = prev.map((part) => {
        if (part.partCode === partCode) {
          const updatedSerialNumbers = part.serialNumbers.filter(sn => sn !== serialNo);
          const newCount = updatedSerialNumbers.length;
          
          if (part.isSerialized && newCount === 0) {
            // Return null to remove this item later
            return null;
          }
          
          return {
            ...part,
            allocateQty: newCount,
            count: newCount,
            serialNumbers: updatedSerialNumbers
          };
        }
        return part;
      });
      
      // Filter out null entries (removed items) and keep non-serialized parts
      return updatedList.filter(item => item !== null);
    });

    // Update selectedPartForModal to reflect changes in modal UI
    setSelectedPartForModal((prev) => {
        if (!prev) return null;
        const currentCode = prev.code || prev.partCode;
        if (currentCode === partCode) {
            const updatedSerialNumbers = (prev.serialNumbers || serialNoMap[partCode] || []).filter(sn => sn !== serialNo);
            return {
                ...prev,
                serialNumbers: updatedSerialNumbers
            };
        }
        return prev;
    });

    // Close modal if no serial numbers left
    const currentPart = partTableList2.find(p => p.partCode === partCode);
    if (currentPart?.serialNumbers?.length === 1) {  // If this is the last serial number
      setOpen(false);
    }

    toast.success("Serial number deleted successfully");
  };

  const handleDeleteRow = (partCode) => {
    setPartTableList2((prev) => prev.filter((item) => item.partCode !== partCode));
    toast.success("Item removed from allocation list");
  };

  const handleAllocate = async () => {
    // Validate required fields
    if (!selectedServiceCenter?._id || !selectedEngineer?._id) {
      toast.error("Please select both Service Center and Engineer");
      return;
    }

    if (partTableList2.length === 0) {
      toast.error("Please add parts to the list before allocating");
      return;
    }

    // Format the data according to the required structure
    const formattedData = {
      serviceCenterId: selectedServiceCenter._id,
      engineerId: selectedEngineer._id,
      parts: partTableList2.map(part => ({
        partId: part.type === 'model' ? part.modelId : part.partId,
        allocatedQty: part.allocateQty,
        serialNumber: part.serialNumbers || [],
        isSerialized: part.isSerialized,
        type: part.type
      }))
    };

    try {
      setLoading(true);
      const response = await transferPartAllocation(formattedData);
      
      if (response.status === 200) {
        toast.success(response.data.message);
        // Clear all related states
        setPartTableList2([]);
        setSelectedServiceCenter(null);
        setSelectedEngineer(null);
        setEngineerList([]);
        setSerialNoMap({});
        setSerialNoInputs({});
        setSelectedPartForModal(null);
        setOpen(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error allocating parts:", error);
      toast.error(error.response?.data?.message || "Failed to allocate parts");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckPartSerialNo = async () => {
    if (!selectedPart?._id) {
      toast.error("Invalid part selected");
      return;
    }

    if (!selectedServiceCenter?._id) {
      toast.error("Please select a Service Center first");
      return;
    }

    const params = {
      serialNumber: serialNoInputs[selectedPart._id] || '',
      partId: selectedPart._id,
      serviceCenterId: selectedServiceCenter._id
    }
    try {
      const response = await checkPartSerialNo(params);
      if (response.status === 200) {  
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error checking part serial no:", error);
      toast.error(error.response?.data?.message || "Failed to check part serial no");
    }
  }

  // Add new handler for reset button
  const handleReset = () => {
    setSelectedBrand(null);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSelectedModel(null);
    setSelectedPart(null);
    setCategories([]);
    setSubcategories([]);
    setModels([]);
    setPartList([]);
    setPartTableList([]);
    setPartTableList2([]);
    setSelectedServiceCenter(null);
    setSelectedEngineer(null);
    setEngineerList([]);
    setBulkFile(null);
    setSerialNoMap({});
    setSerialNoInputs({});
  };

  // Add new handler for first cancel button
  const handleFirstCancel = () => {
    setPartTableList([]);
    setPartTableList2([]);
    setSerialNoMap({});
    setSelectedPart(null);
    setSerialNoInputs({});
  };

  // Add new handler for second cancel button
  const handleSecondCancel = () => {
    setPartTableList2([]);
    setSelectedServiceCenter(null);
    setSelectedEngineer(null);
    setEngineerList([]);
  };

  const handleBulkFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xlsx" && fileExtension !== "xls") {
        toast.error("Only Excel files (.xlsx, .xls) are allowed");
        event.target.value = null;
        return;
      }
      setBulkFile(file);
    }
  };

  const handleBulkUpload = async () => {
    if (!bulkFile) {
      toast.error("Please select a file to upload");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", bulkFile);
      const response = await importBufferStock(formData);
      if (response.status === "error") {
        toast((t) => <BulkUploadToast t={t} response={response} />, {
          duration: Infinity,
        });
        setBulkFile(null);
      } else if (response.status === "success") {
        toast.success(response.message || "Bulk upload successful!");
        setBulkFile(null);
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      toast.error(error.response?.data?.message || "Something went wrong during Bulk Upload");
    } finally {
      setLoading(false);
    }
  };

   const handleDownloadReferenceCode = async () => {
     try {
       setLoading(true);
       const response = await downloadTransferStockReferenceCode();
       if (response?.status === "success" && response?.data?.filePath) {
         window.location.href = response.data.filePath;
         toast.success("Reference code downloaded successfully");
       } else {
         throw new Error("Invalid response from server");
       }
     } catch (error) {
       console.error("Error downloading reference code:", error);
       toast.error(error.message || "Failed to download reference code");
     } finally {
       setLoading(false);
     }
   };

  const handleDownloadStockGRNTemplate = () => {
    window.location.href = `${process.env.REACT_APP_TEMPLETE_URL}/excel/Stock_GRN.xlsx`;
    toast.success("Stock GRN Template downloaded successfully!");
  };

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Inventory"} />
      <DynamicTabs />
      <Grid
        container
        sx={{
          background: "#F5F8FF",
          margin: "0 10px 10px",
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container gap={3}>
          <Grid item sx={{ marginTop: "10px" }}>
            <Subheader heading={"Upload using"} />
          </Grid>
          <Grid item sx={{ marginTop: "0" }}>
            <RadioGroup
              row
              value={selectedValue}
              onChange={handleChange}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel value="UI" control={<Radio />} label="UI" />
              <FormControlLabel
                value="excel"
                control={<Radio />}
                label="Excel"
              />
            </RadioGroup>
          </Grid>
        </Grid>
        {selectedValue === "UI" ? (
          <>
            <Grid container gap={5}>
              <Grid item>
                <Autocomplete
                  id="service-center-autocomplete"
                  options={serviceCenterList}
                  getOptionLabel={(option) => option.serviceCenter || ""}
                  value={selectedServiceCenter}
                  onChange={(event, newValue) => {
                    setSelectedServiceCenter(newValue);
                    setAllocateListParams((prev) => ({
                      ...prev,
                      serviceCenterId: newValue?._id || "",
                    }));
                    
                    // Reset only lists and engineer, keep filter selections
                    setPartTableList([]);
                    setPartTableList2([]);
                    setSerialNoMap({});
                    setSerialNoInputs({});
                    setSelectedEngineer(null);

                    if (newValue?._id) {
                      getEngineerList(newValue._id);
                    } else {
                      setEngineerList([]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transfer From"
                      variant="standard"
                      style={{ width: "12rem" }}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="engineer-autocomplete"
                  options={engineerList}
                  getOptionLabel={(option) => option.name || ""}
                  value={selectedEngineer}
                  onChange={(event, newValue) => {
                    setSelectedEngineer(newValue);
                    setAllocateListParams((prev) => ({
                      ...prev,
                      engineerId: newValue?._id || "",
                    }));
                  }}
                  disabled={!selectedServiceCenter}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transfer To"
                      variant="standard"
                      style={{ width: "12rem" }}
                      helperText={
                        !selectedServiceCenter
                          ? "Please select service center first"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                background: "#F5F8FF",
                marginTop: "10px",
                width: "100%",
                borderRadius: "5px",
                padding: "10px",
                fontWeight: 600,
              }}
            >
              <Grid container gap={5}>
                <Grid item>
                  <Autocomplete
                    id="brand-autocomplete"
                    options={brandList}
                    getOptionLabel={(option) => option.brandName || ""}
                    value={selectedBrand}
                    onChange={(event, newValue) => {
                      setSelectedBrand(newValue);
                      setSelectedCategory(null);
                      setSelectedSubcategory(null);
                      setSelectedModel(null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Brand"
                        variant="standard"
                        style={{ width: "12rem" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Autocomplete
                    id="category-autocomplete"
                    options={categories}
                    getOptionLabel={(option) => option.categoryName || ""}
                    value={selectedCategory}
                    onChange={(event, newValue) => {
                      setSelectedCategory(newValue);
                      setSelectedSubcategory(null);
                      setSelectedModel(null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Category"
                        variant="standard"
                        style={{ width: "12rem" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Autocomplete
                    id="subcategory-autocomplete"
                    options={subcategories}
                    getOptionLabel={(option) => option.subcategoryName || ""}
                    value={selectedSubcategory}
                    onChange={(event, newValue) => {
                      setSelectedSubcategory(newValue);
                      setSelectedModel(null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sub Category"
                        variant="standard"
                        style={{ width: "12rem" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Autocomplete
                    id="model-autocomplete"
                    options={models}
                    getOptionLabel={(option) => option.modelName || ""}
                    value={selectedModel}
                    onChange={(event, newValue) => {
                      setSelectedModel(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Model"
                        variant="standard"
                        style={{ width: "12rem" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Autocomplete
                    id="part-code-select"
                    options={partList}
                    getOptionLabel={(option) => option.sparePartCode || ""}
                    value={selectedPart}
                    onChange={(event, newValue) => {
                      setSelectedPart(newValue);
                    }}
                    disabled={!selectedModel}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Part Code"
                        variant="standard"
                        style={{ width: "12rem" }}
                        helperText={
                          !selectedModel ? "Please select a model first" : ""
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Autocomplete
                    id="part-name-select"
                    options={partList}
                    getOptionLabel={(option) => option.sparePartName || ""}
                    value={selectedPart}
                    onChange={(event, newValue) => {
                      setSelectedPart(newValue);
                    }}
                    disabled={!selectedModel}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Part Name"
                        variant="standard"
                        style={{ width: "12rem" }}
                        helperText={
                          !selectedModel ? "Please select a model first" : ""
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container gap={3} mt={5}>
                <CommonButton name="Search" handleOnClick={handleSearch} />
                <CommonButton name="Reset" handleOnClick={handleReset} />
              </Grid>
            </Grid>
          </>
        ) : (
          <BulkUploadSection
            onFileChange={handleBulkFileChange}
            onUpload={handleBulkUpload}
            onDownloadTemplate={handleDownloadStockGRNTemplate} 
            onDownloadReference={handleDownloadReferenceCode} 
            fileName={bulkFile?.name}
          />
        )}
      </Grid>

      {selectedValue === "UI" && (
        <Grid
          container
          sx={{
            background: "#EFF3FE",
            marginLeft: "10px",
            marginTop: "4px",
            marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            fontWeight: 600,
          }}
        >
        <Grid container>
          {/* <Grid container justifyContent="flex-end">
            <ExportToExcel
              name="Export to Excel"
              data={rows}
              fileName="Brand_Data"
              headers={cells}
            />
          </Grid> */}
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cell1.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{ color: "white", textAlign: "center" }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {partTableList.length > 0 ? (
                  partTableList.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.name}</TableCell>
                      <TableCell align="center">{row.code}</TableCell>
                      <TableCell align="center">{row.type}</TableCell>
                      <TableCell align="center">{row.quantity}</TableCell>
                      <TableCell align="center">
                        {row.isSerialized ? (
                          row.allocateQty || 0
                        ) : (
                          <TextField
                            variant="standard"
                            value={row.allocateQty || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                handleQuantityChange(row.code, value);
                              }
                            }}
                            sx={{ width: "5rem" }}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ display: "flex", margin: "0", justifyContent: "center" }}
                      >
                        {row.isSerialized ? (
                          <>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                              <TextField
                                id={`serial-input-${row.code}`}
                                label=""
                                variant="standard"
                                sx={{ width: "8rem" }}
                                value={serialNoInputs[row.code] || ''}
                                onChange={(e) => handleSerialNoInputChange(row.code, e.target.value)}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    handleAddSerialNo(row.code);
                                  }
                                }}
                              />
                              <CommonButton
                                name={"Add"}
                                handleOnClick={() => handleAddSerialNo(row.code)}
                              />
                            </Box>
                          </>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {row.isSerialized ? (
                          <>
                            {serialNoMap[row.code]?.length || 0}
                            <IconButton
                              onClick={() => handleShowSerialNos(row)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={infoIcon}
                                alt="active"
                                height={"20px"}
                                width={"20px"}
                              />
                            </IconButton>
                          </>
                        ) : (
                          row.allocateQty || 0
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={cell1.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid container gap={3}>
            <CommonButton
              name={"Add to List"}
              handleOnClick={handleAddToList}
            />
            <CommonButton
              name={"Cancel"}
              handleOnClick={handleFirstCancel}
            />
          </Grid>
          {partTableList2.length > 0 && (
            <>
              <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      {cell2.map((cell, index) => (
                        <TableCell
                          key={index}
                          sx={{ color: "white", textAlign: "center" }}
                        >
                          {cell}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {partTableList2.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{row.partName}</TableCell>
                        <TableCell align="center">{row.partCode}</TableCell>
                        <TableCell align="center">{row.allocateQty}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            onClick={() =>
                              handleShowSerialNos({
                                code: row.partCode,
                                serialNumbers: row.serialNumbers,
                              })
                            }
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                          >
                            <img
                              src={infoIcon}
                              alt="active"
                              height={"20px"}
                              width={"20px"}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center">{row.count}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            onClick={() => handleDeleteRow(row.partCode)}
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height={"20px"}
                              width={"20px"}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container gap={3}>
                <CommonButton name={"Allocate"} handleOnClick={handleAllocate} />
                <CommonButton name={"Cancel"} handleOnClick={handleSecondCancel} />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="serial-no-modal"
        aria-describedby="modal-to-show-serial-numbers"
      >
        <SerialNoModal
          serialNumbers={
            selectedPartForModal
              ? selectedPartForModal.serialNumbers ||
                serialNoMap[selectedPartForModal.code] ||
                []
              : []
          }
          onClose={handleClose}
          onDelete={handleDeleteSerialNo}
          partCode={selectedPartForModal?.code || selectedPartForModal?.partCode}
        />
      </Modal>
    </Grid>
  );
};

export default Bufferstockallocation;